<template>
    <div style="width: fit-content">
        <v-tabs v-model="tabValue" grow @update:model-value="onTabChange">
            <v-tab v-for="item in items" :key="item.value" :value="item.value" :data-cy="item.dataCy">
                {{ item.title }}
            </v-tab>
        </v-tabs>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps<{
    items: { title: string; value: any; dataCy?: string }[];
    modelValue: any;
}>();
const emit = defineEmits<{
	(event: "update:modelValue", val: any): void;
}>();

const tabValue = ref(props.modelValue);

watch(
	() => props.modelValue,
	(val) => {
		tabValue.value = val;
	}
);

function onTabChange(val: any) {
	emit("update:modelValue", val);
}
</script>
